<template>
  <v-container fluid id="daily-report-summary" class="pt-0">
    <!-- Photos Carousel Section -->
    <v-dialog
      v-model="photosDialog"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-toolbar dark color="primary" v-if="photoGroups">
        <v-btn icon dark @click="photosDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-divider vertical class="ml-2 mr-4"></v-divider>
        <v-icon @click="carousel--" class="mr-3">
          chevron_left
        </v-icon>
        {{ carousel + 1 }}/{{
          photoGroups[carouselPhotoType] &&
            photoGroups[carouselPhotoType].length
        }}
        <v-icon @click="carousel++" class="ml-3">
          chevron_right
        </v-icon>
        <v-toolbar-title class="ml-3">
          {{ carouselPhotoType }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-carousel
            v-model="carousel"
            hide-delimiter-background
            hide-delimiters
            height="auto"
            :show-arrows="false"
            class="pt-2"
          >
            <v-carousel-item
              v-for="photo in photoGroups[carouselPhotoType]"
              :key="photo.id"
            >
              <v-img
                :src="
                  photo.url.replace(
                    'https://firebasestorage.googleapis.com/',
                    'https://ik.imagekit.io/albademo/tr:w-1400/'
                  )
                "
                style="height:90vh"
                contain
                position="top center"
              ></v-img>
            </v-carousel-item>
          </v-carousel>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- JOBSITE AND DATE  SECTION-->
    <v-row wrap>
      <v-col cols="12" sm="12" md="12" lg="8" class="pa-0 mb-2">
        <v-card dark color="primary" v-if="jobSite">
          <v-card-title>
            <v-btn icon class="mr-2" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            {{ jobSite.street }}
          </v-card-title>
          <v-card-text>
            <v-btn text outlined rounded small @click="goToToday" class="mr-1"
              >TODAY</v-btn
            >
            <v-btn icon @click="goToPrevDay" small
              ><v-icon>chevron_left</v-icon></v-btn
            >
            <v-dialog
              ref="dialog"
              v-model="datePickerDialog"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  small
                  rounded
                  class="date-btn"
                  v-bind="attrs"
                  v-on="on"
                  >{{ $route.params.date | moment("ddd MMM Do YYYY") }}</v-btn
                >
              </template>
              <v-date-picker v-model="date" scrollable color="primary">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="datePickerDialog = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="goToDate(date)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>

            <v-btn icon @click="goToNextDay" small
              ><v-icon>chevron_right</v-icon></v-btn
            >
            <v-btn
              style="position: absolute;top:10px;right:10px"
              icon
              target="_blank"
              @click="generatePDF"
              ><v-icon>picture_as_pdf</v-icon></v-btn
            >
          </v-card-text>
        </v-card>
        <v-card
          dark
          color="primary lighten-1 mt-1"
          class="mb-5"
          v-if="dailyReport && complete"
        >
          <v-card-text class="white--text py-0">
            <v-row>
              <v-col cols="12" xs="12" sm="8">
                <div v-if="complete">
                  Prepared by
                  <strong
                    >{{ dailyReport.completedBy.firstName }}
                    {{ dailyReport.completedBy.lastName }}</strong
                  >
                  for
                  {{ date | moment("MMM Do [at] h:mma") }}
                  <br />
                  <div class="caption">{{ jobSite.address }}</div>
                </div>
              </v-col>
              <v-col>
                <div class="text-sm-right">
                  JobID: {{ jobSite && jobSite.jobId }} <br />
                  <div class="caption">{{ jobSite.department.join(", ") }}</div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card
          v-if="dailyReport && complete && dailyReport.projectPhase"
          class="mt-1 mb-5"
        >
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div class="font-weight-bold">Project Phase:</div>
                <v-chip 
                  small 
                  :color="getPhaseColor(dailyReport.projectPhase)"
                  text-color="white"
                >
                  {{ dailyReport.projectPhase.charAt(0).toUpperCase() + dailyReport.projectPhase.slice(1) }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card
          v-if="dailyReport && complete && dailyReport.weather"
          style="background: #f7faff;box-shadow: none;border: solid 1px #314e71;"
        >
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                sm="4"
                class="pa-0 text-center"
                v-for="(item, ix) in dailyReport.weather.summary"
                :key="ix"
              >
                <div class="caption">
                  <strong>{{ item.time_epoch | moment("h:mm a") }}</strong>
                </div>
                <div
                  class="d-flex"
                  style="justify-content:center;align-items:center"
                >
                  <div style="font-size:40px">{{ parseInt(item.temp_f) }}°</div>
                  <div>
                    <img
                      contain
                      :src="item.condition.icon"
                      style="width:40px"
                    />
                  </div>
                </div>
                <div>
                  <strong>{{ item.condition.text }}</strong>
                </div>
                <div class="caption">
                  Wind: {{ parseInt(item.wind_mph) }} MPH
                  <span style="opacity:.3;padding:0 6px">|</span> Precip.
                  {{ parseInt(item.precip_in) }}"
                  <span style="opacity:.3;padding:0 6px">|</span> Humidity
                  {{ parseInt(item.humidity) }}%
                </div>
                <v-divider class="my-2 d-sm-none"></v-divider>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="mt-1" v-if="!loading && !complete">
          <v-card-text>
            <div class="pa-4">
              Report Not Submitted.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- SUMMARY SECTION-->
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="8" class="pa-0">
        <div v-if="!loading && dailyReport && dailyReport.complete">
          <v-card class="mb-4">
            <v-card-title>
              Daily Activities
            </v-card-title>
            <v-card-text>
              <v-divider></v-divider>
              <div
                v-for="(activity, index) in activities"
                :key="index"
                class="pa-2 mb-2"
                style="white-space:pre-line"
              >
                <div class="mb-1">
                  <strong>{{ activity.activityCategory }}</strong>
                </div>
                <p>{{ activity.activityDescription }}</p>
              </div>
            </v-card-text>
          </v-card>
          <!-- PHOTOS -->
          <v-card class="mb-4">
            <v-card-title>
              Photos
            </v-card-title>
            <v-card-text>
              <v-divider></v-divider>
              <div v-if="dailyReportPhotos.length" class="pt-2 pl-2">
                <div v-for="(photos, type) in photoGroups" :key="type">
                  <h4>{{ type }}</h4>
                  <v-card
                    style="width:100px;height:100px;display:inline-block;"
                    class="mr-2 mb-2"
                    v-for="(photo, ix) in photos"
                    :key="ix"
                  >
                    <v-card-text class="pa-0">
                      <a
                        @click="
                          carousel = ix;
                          carouselPhotoType = photo.photoType;
                          photosDialog = true;
                        "
                      >
                        <img
                          :src="
                            photo.url.replace(
                              'https://firebasestorage.googleapis.com/',
                              'https://ik.imagekit.io/albademo/tr:w-100/'
                            )
                          "
                          height="100"
                          width="100"
                          style="display:inline-block"
                          class="mr-2"
                        />
                      </a>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <!-- SURVEY -->
          <v-card class="mb-4">
            <v-card-title>
              Survey
            </v-card-title>
            <v-card-text>
              <v-divider></v-divider>
              <div class="mt-0 pa-3" v-if="survey.length">
                <v-simple-table>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Question</strong>
                      </td>
                      <td>
                        <strong>Answer</strong>
                      </td>
                      <td>
                        <strong>Description</strong>
                      </td>
                    </tr>
                    <tr v-for="sq in survey" :key="sq.question">
                      <td>
                        {{ sq.question }}
                      </td>
                      <td>
                        <strong
                          :class="{ 'grey--text': sq.answer === 'N/A' }"
                          >{{ sq.answer }}</strong
                        >
                      </td>
                      <td>
                        {{ sq.description }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </v-card-text>
          </v-card>
          <!-- SIGNATURE -->
          <v-card class="mb-4" v-if="dailyReport && dailyReport.signature">
            <v-card-title>
              Digital Signature
            </v-card-title>
            <v-card-text>
              <v-divider></v-divider>
              <div class="mt-3">
                <div class="mb-2">
                  <img 
                    :src="dailyReport.signature.signatureData" 
                    style="max-width: 300px; border: 1px solid #ccc; background: white;"
                    alt="Digital Signature"
                  />
                </div>
                <div class="caption">
                  <strong>Signed by:</strong> 
                  {{ dailyReport.signature.signedBy.firstName }} {{ dailyReport.signature.signedBy.lastName }}
                  <br />
                  <strong>Date:</strong> 
                  {{ dailyReport.signature.signedAt.toDate() | moment("MMM Do YYYY [at] h:mma") }}
                </div>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="mb-4">
            <v-card-title>
              Recent Dump Report
            </v-card-title>
            <v-card-text>
              <v-divider></v-divider>
              <v-data-table
                :items="truckRequests"
                :headers="headers"
                disable-sort
                :items-per-page="150"
                :hide-default-footer="true"
                dense
                class="truckReportTable"
              >
                <template v-slot:item.createDate="{ item }">
                  {{ item.createDate.toDate() | moment("MM/DD/YYYY") }}
                </template>
                <template v-slot:item.yards="{ item }">
                  {{ item.yards }}
                </template>
                <template v-slot:item.loadWeight="{ item }">
                  {{ item.loadWeight }}
                  <span class="caption">{{ item.loadWeightType }}</span>
                </template>
                <template v-slot:item.dumpTicketImage="{ item }">
                  <v-btn
                    icon
                    small
                    v-for="image of item.dumpTicketImage"
                    :key="image"
                    target="_blank"
                    :href="image"
                  >
                    <v-icon small>image</v-icon>
                  </v-btn>
                </template>
                <template v-slot:item.request="{ item }">
                  <a
                    :href="`/truck-requests/manage/orders/${item.requestId}`"
                    target="_blank"
                    >view</a
                  >
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </div>
        <v-card class="mb-4" v-if="loading">
          <v-card-text>
            <div class="pa-4">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import fb from "@/main";
import moment from "moment";
import { mapState } from "vuex";
import { groupBy, sortBy } from "lodash";
export default {
  data() {
    return {
      carouselPhotoType: null,
      datePickerDialog: false,
      carousel: 0,
      photosDialog: false,
      dailyReport: null,
      jobSiteId: null,
      dailyReportRef: null,
      date: null,
      activities: [],
      dailyReportPhotos: [],
      loading: true,
      tab: "tab-1",
      jobSite: null,
      valid: false,
      submitting: false,
      submitted: false,
      modal: false,
      snack: false,
      snackColor: "",
      snackText: "",
      // new notes
      activityCategory: "General Notes",
      activityDescription: "",
      // survey
      survey: [],
      uploadingImages: false,
      complete: false,
      truckRequests: [],
      headers: [
        { text: "Date", value: "createDate", width: 110 },
        { text: "Yrds", value: "yards", width: "60" },
        { text: "Driver", value: "driverName" },
        { text: "Location", value: "dumpSite" },
        { text: "Load Weight", value: "loadWeight" },
        { text: "Image", value: "dumpTicketImage", width: "100" },
        { text: "Request", value: "request", width: "100", align: "center" },
      ],
    };
  },
  computed: {
    ...mapState(["user", "jobSites"]),
    photoGroups() {
      return groupBy(this.dailyReportPhotos, "photoType");
    },
  },
  watch: {
    $route() {
      this.init();
    },
  },
  async created() {
    this.init();
  },
  methods: {
    goBack() {
      // Always go to the daily reports list. Hardcoding (vs. router.back) keeps
      // this predictable no matter how the user arrived — a deep link or new tab
      // has no in-app history, so router.back would leave the app entirely.
      this.$router.push("/admin/daily-reports");
    },
    async init() {
      this.jobSiteId = this.$route.params.jobSiteId;
      this.date = this.$route.params.date;
      this.dailyReport = null;
      this.dailyReportId = `${this.date}-${this.jobSiteId}`;
      this.dailyReportRef = fb.db.doc(`dailyReports/${this.dailyReportId}`);
      this.dailyReportPhotos = [];
      this.survey = [];
      this.activities = [];
      this.getDailyReport();
      this.getTruckRequests();
    },
    async getDailyReport() {
      try {
        const doc = await fb.db.doc(`jobSites/${this.jobSiteId}`).get();
        this.jobSite = doc.data();
        const dr = await this.dailyReportRef.get();
        this.complete = false;
        if (dr.exists) {
          this.loading = true;
          const dailyReport = dr.data();
          this.complete = dailyReport.complete || false;
          this.dailyReport = dailyReport;
          this.survey = dailyReport.survey;
          this.crewSize = dailyReport.crewSize;
          await this.getDailyReportPhotos();
          await this.getDailyReportActivities();
          this.loading = false;
        } else {
          // TODO: report does not exists
          this.loading = false;
          return;
        }
      } catch (error) {
        console.log(error);
        this.showSnack("error", "Error loading daily report.");
        this.loading = false;
      }
    },
    async getDailyReportPhotos() {
      this.dailyReportPhotos = [];
      const att = await fb.db
        .collection("dailyReportPhotos")
        .where("date", "==", this.date)
        .where("jobSiteId", "==", this.jobSiteId)
        .get();
      const dailyReportPhotos = [];
      att.forEach((a) => {
        dailyReportPhotos.push({
          id: a.id,
          ...a.data(),
        });
      });
      this.dailyReportPhotos = dailyReportPhotos;
    },
    async getDailyReportActivities() {
      this.activities = [];
      const att = await fb.db
        .collection("dailyReportActivities")
        .where("date", "==", this.date)
        .where("jobSiteId", "==", this.jobSiteId)
        .get();
      const activities = [];
      att.forEach((a) => {
        activities.push({
          id: a.id,
          ...a.data(),
        });
      });
      this.activities = activities;
    },
    async getTruckRequests() {
      const fbRes = await fb.db
        .collection("truckRequests")
        .where("status", "==", "closed")
        .where("jobSite.id", "==", this.jobSiteId)
        .orderBy("orderDate", "desc")
        .orderBy("dumpTickets", "asc")
        .limit(5)
        .get();
      var closedRequests = [];
      fbRes.forEach(function(doc) {
        closedRequests.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      const dumpTickets = [];
      closedRequests.forEach((tr) => {
        if (tr.dumpTickets) {
          const tickets = Object.values(tr.dumpTickets);
          dumpTickets.push(
            tickets.map((t) => {
              return {
                ...t,
                materialTypeBreakdown: tr.materialTypeBreakdown,
                jobSite: tr.jobSite,
                requestId: tr.orderNumber,
                orderDate: tr.orderDate,
                requestDate: tr.requestDate,
                driverName: `${tr.scheduledDriver.firstName} ${tr.scheduledDriver.lastName}`,
                client: tr.jobSite.jobId.startsWith("TR") ? "External" : "ALBA",
              };
            })
          );
        }
      });
      this.truckRequests = sortBy(dumpTickets.flat(), "requestDate").reverse();
    },
    goTo(date) {
      this.$router.push(`/daily-reports/${this.jobSiteId}/${date}/summary`);
    },
    goToNextDay() {
      const tomorrow = moment(this.date)
        .add(1, "d")
        .format("YYYY-MM-DD");
      this.goTo(tomorrow);
    },
    goToToday() {
      const today = moment().format("YYYY-MM-DD");
      const todayPath = `/daily-reports/${this.jobSiteId}/${today}`;
      if (this.$route.fullPath !== todayPath) {
        this.goTo(today);
      }
    },
    goToDate(date) {
      const todayPath = `/daily-reports/${this.jobSiteId}/${date}`;
      if (this.$route.fullPath !== todayPath) {
        this.goTo(date);
      }
      this.datePickerDialog = false;
    },
    goToPrevDay() {
      const yesterday = moment(this.date)
        .subtract(1, "d")
        .format("YYYY-MM-DD");
      this.goTo(yesterday);
    },
    showSnack(color = "success", msg = "Updated successfully!") {
      this.snack = true;
      this.snackColor = color;
      this.snackText = msg;
    },
    generatePDF() {
      const url = `https://us-central1-alba-demolition.cloudfunctions.net/dailyReportGeneratePDF?jobSiteId=${this.jobSiteId}&date=${this.date}`;
      window.open(url, "_blank");
    },
    getPhaseColor(phase) {
      const colors = {
        'mobilization': 'orange',
        'in progress': 'green', 
        'demobilization': 'red'
      };
      return colors[phase] || 'grey';
    },
  },
};
</script>
<style scoped>
.active-tab {
  background: whitesmoke;
}
.v-tab {
  padding-left: 6px;
  padding-right: 6px;
}
.tab-item-container {
  border-top: solid 1px #efefef;
  font-size: 14px;
}
.date-btn {
  text-transform: capitalize;
}
.photos-wrapper {
  border-radius: 5px;
}
.opacity-change {
  opacity: 0.4;
}
>>> .truckReportTable td {
  padding: 0 8px !important;
}
</style>
